import React, { Component, Fragment } from 'react';
import {
	IMfaSetupCallProps,
	IMfaSetupCallState,
} from './models';
import { inject, observer } from 'mobx-react';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';
import Buttons from './styledComponents/Buttons';
import PrefixTextWrapper from './styledComponents/PrefixTextWrapper';
import SuffixTextWrapper from './styledComponents/SuffixTextWrapper';
import LoadingWrapper from './styledComponents/LoadingWrapper';
import InfoMessage from '../App/styledComponents/InfoMessage';
import ErrorMessage from '../App/styledComponents/ErrorMessage';
import LoadingIndicator from '@kurtosys/ksys-app-components/dist/components/base/LoadingIndicator';
import ButtonRaised from '../App/styledComponents/ButtonRaised';
import Heading from '@kurtosys/ksys-app-components/dist/components/base/Heading';
import { MfaSetupCallStore } from './stores/MfaSetupCallStore';
import PhoneNumber from '../PhoneNumber';

@inject('appStore', 'mfaSetupCallStore', 'messageStore')
@observer
export class MfaSetupCall extends Component<IMfaSetupCallProps, IMfaSetupCallState> {
	static configurationKey: 'mfaSetupCall' = 'mfaSetupCall';
	static styleKey: 'mfaSetupCall' = 'mfaSetupCall';
	constructor(props: IMfaSetupCallProps) {
		super(props);
	}
	render() {
		const { className, mfaSetupCallStore, messageStore } = this.props;
		const { componentKey } = MfaSetupCallStore;

		if (!mfaSetupCallStore || !messageStore) {
			return null;
		}
		const {
			headingText,
			prefixText,
			suffixText,
			loadingAuth,
			finishMfaSetup,
			finishButtonText,
			verifyCall,
			callButtonText,
			confirmedCall,
			phoneNumberProps,
		} = mfaSetupCallStore;
		return (
			<Wrapper className={ className }>
				<Heading level={ 1 } title={ headingText } />
				<PrefixTextWrapper>
					<InfoMessage>
						{ prefixText }
					</InfoMessage>
				</PrefixTextWrapper>
				<PhoneNumber { ...phoneNumberProps } />
				<SuffixTextWrapper>
					<InfoMessage>
						{ suffixText }
					</InfoMessage>
				</SuffixTextWrapper>
				<ErrorMessage>
					{ messageStore.errorTexts.get(componentKey) }
				</ErrorMessage>
				{ loadingAuth && (
					<LoadingWrapper>
						<LoadingIndicator />
					</LoadingWrapper>
				) }
				{ !loadingAuth &&
					<Fragment>
						<Buttons>
							<ButtonRaised onClick={ verifyCall }>{ callButtonText }</ButtonRaised>
						</Buttons>
						{
							confirmedCall && (
								<ButtonRaised onClick={ finishMfaSetup }>{ finishButtonText }</ButtonRaised>
							)
						}
					</Fragment>
				}
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(MfaSetupCall, 'mfaSetupCall');

